import { render } from "./PlayerTeamModal.vue?vue&type=template&id=2d1872aa&scoped=true"
import script from "./PlayerTeamModal.vue?vue&type=script&lang=js"
export * from "./PlayerTeamModal.vue?vue&type=script&lang=js"

import "./PlayerTeamModal.vue?vue&type=style&index=0&id=2d1872aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1872aa"]])

export default __exports__